import Feedback from 'feedback.js';
import { feedbackOptions } from 'server-data/footer-feedback-portal';
import { getUserIdfromCookie } from '@shared/cookie';

const f = Feedback({
  appendTo: null, // don't add feedback button to page
  url: '/ajax/reporting/submit.php',
  skipClass: ['sky-upper'],
  feedbackOptions,
  isLoggedIn: !!getUserIdfromCookie(),
});

document.getElementById('open-feedback').addEventListener('click', () => {
  // Check for the existence of the feedback modal. Don't open a new one if
  // there's one already opened.
  const element = document.querySelector('.feedback-modal');
  if (!element) {
    f.open();
    // Focus on the first select element encountered.
    const selectElement = document.querySelector('.feedback-modal select');
    if (selectElement) {
      selectElement.focus();
    }
  }
});
